module.exports = __webpack_public_path__ + "static/media/sf-trial-2-correct.bd3c4efa.mp3";